module.exports = __webpack_public_path__ + "img/nginx.022125f.svg";